import { gqlClient } from '../../components/AppProvider';
import { AppDispatch, AppThunk } from '../../store';
import { PagingResultModelOfMessagingLogModel, GetMessagingLogsInput, RequestResult, DocumentStatus } from '../../gql-types.generated';
import { queryMessagingLogList } from "../../gql/QueryMessagingLogList";
import { captureUpdateLogsStatus, clearError, decrementEventLogRequestsInFlight, fetchError, fetchEventLogListSuccess, incrementEventLogRequestsInFlight, setCurrentPage, selectPageCursors } from './EventLogsSlice';
import { mutationExecuteEdiActionSvcAction } from '../../gql/MutationExecuteEdiActionSvcAction';
import { getErrorMessage } from '../../util/Common';
import { serializeError } from '../../util/ErrorSerialization';

// Unified pagination action
export const fetchEventLogList = (
    targetPage: number,
    filters?: GetMessagingLogsInput
): AppThunk => async (dispatch: AppDispatch, getState): Promise<void> => {
    const state = getState();
    const pageCursors = selectPageCursors(state);
    
    // Clear any previous error when starting a new fetch
    dispatch(clearError());
    
    // Set the current page first
    dispatch(setCurrentPage(targetPage));
    
    // Determine the cursor to use - cursor gets you TO the target page
    let cursor: string | undefined;
    if (targetPage === 1) {
        cursor = undefined; // First page uses no cursor
    } else {
        // For page N, we need the cursor from page N-1 that points to page N
        cursor = pageCursors[targetPage];
    }
    
    // Update filters with the cursor
    const updatedFilters = {
        ...filters,
        after: cursor
    };
    
    dispatch(incrementEventLogRequestsInFlight());
    try {
        const eventLogList = await queryMessagingLogList(gqlClient, updatedFilters);
        if (eventLogList) {
            dispatch(fetchEventLogListSuccess(eventLogList as PagingResultModelOfMessagingLogModel))
        }
        dispatch(decrementEventLogRequestsInFlight());
    } catch (e) {
        dispatch(fetchError(serializeError(e as Error)));
        dispatch(decrementEventLogRequestsInFlight());
    }
};

export const updateEventLogsDocumentStatus = (ids: string[], status: DocumentStatus): AppThunk =>
    async (dispatch: AppDispatch): Promise<void> => {
        try {
            let actionArguments = `{MessagingLogIds: ${JSON.stringify(ids)}, Status: ${JSON.stringify(status)}}`;
            const updateStatus = await mutationExecuteEdiActionSvcAction(gqlClient, {
                actionName: "UpdateMessagingLogStatusAction",
                actionArguments: actionArguments
            });
            if (updateStatus) {
                if (updateStatus.result === RequestResult.Fail) {
                    getErrorMessage(updateStatus.message as string, updateStatus.errors, true, true);
                }
                dispatch(captureUpdateLogsStatus(updateStatus));
            }
        } catch (e) {
            dispatch(fetchError(serializeError(e as Error)));
        }

    };

